import $ from 'jquery';
import { loadScript } from "@paypal/paypal-js";

class PayGateway{

    clientId = "TEST";
    alerts = null;

    constructor(){
        if(document.getElementById("paypal-button-container")){
            this.getClientId();
            this.events();
            this.alerts = document.getElementById("alerts");
        }
    }

    events(){
        setTimeout(()=>{
            // console.log(this.clientId);
            this.loadPaypalJS();
        }, 2000);
    }

    getClientId(){
        $.ajax({
            url: sgttData.root_url + '/wp-json/sgtt/v1/get-client-id',
            method: "GET",
            headers: {"X-WP-Nonce": sgttData.nonce},
            success: (rs) => { 
                this.clientId = rs.clientId;
            },
            error: (er) => {
                console.log("ERRR: ");
                console.log(er)
            }
        });
    }

    loadPaypalJS(){
        loadScript({ 
            "client-id": this.clientId,
            "currency": "USD"
        })
        .then((paypal) => {
            // start to use the PayPal JS SDK script
            let intent = "CAPTURE";
            let body;
            let alerts = document.getElementById("alerts");

            function processCancelOrder(){
                // Customer cancel payment on paypal.
                $('.payment-msg').removeClass('d-none');
                alerts.append(` Order cancelled!`);
            }

            function processOrderSuccess(order_details){
                // payment successfully.!!!
                $('.payment-msg').addClass('d-none');
                console.log("Paypay success: "+ body.bookId); //https://developer.paypal.com/docs/api/orders/v2/#orders_capture!c=201&path=create_time&t=response
                //let intent_object = intent === "authorize" ? "authorizations" : "captures";
                //Custom Successful Message
                // alerts.innerHTML = 
                // `<div class=\'ms-alert ms-action\'>Thank you `+ order_details.payer.name.given_name + ` ` + order_details.payer.name.surname + ` 
                // for your payment of ` + order_details.purchase_units[0].payments[intent_object][0].amount.value + ` ` + order_details.purchase_units[0].payments[intent_object][0].amount.currency_code + `!</div>`;
                // Thank you John Doe for your payment of 2.00 USD!
                
                // process save order
               
                $.ajax({
                    type: 'POST',
                    url: booking_order_ajax_object.ajax_url,
                    data: {
                        action: "checkout_order",
                        nonce: booking_order_ajax_object.nonce,
                        cartId: $("input[name='cart-id']").val()
                    },
                    beforeSend: function () {
                        $('.fullscreen-spinner').removeClass('d-none');
                    },
                    success: function (res) {
                        // Xử lý kết quả trả về từ server
                        $('.fullscreen-spinner').addClass('d-none');
                        if (res.success) {
                            let checkout_url = sgttData.root_url + '/thanks?orderid=' + res.data.postID;
                            window.location.href = checkout_url;
                        }
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        $('.fullscreen-spinner').addClass('d-none');
                        console.log('The following error occured: ' + textStatus, errorThrown);
                    }
                });
            }

            function processOrderApproveFailed(){
                $('.payment-msg').removeClass('d-none');
                // The customer has payment but the system did not approve
                alerts.append(` An Error Ocurred! Please contact admin for your transaction.`);
            }

            function processOrderFailed() {
                $('.payment-msg').removeClass('d-none');
                // Customer can't proceed to payment.
                alerts.append(` An Error Ocurred! Please try again or contact admin for more information.`);
            
            }
            // END: Actions on the paypal processing.

            async function initOrderRequestBody(){
                var url = sgttData.root_url + "/wp-json/sgtt/v1/get-booking-paypal-body";
                let data = {
                    "cartId": $("input[name='cart-id']").val()
                };
                const response = await fetch(url, {
                    method: "POST",
                    body: JSON.stringify(data),
                    headers: {
                        "X-WP-Nonce": sgttData.nonce,
                        "Content-Type": "application/json; charset=utf-8"
                    },
                    credentials: 'same-origin'
                });

                return (await response.json());
            }

            let paypal_buttons = paypal.Buttons({
                // START: Actions on the paypal processing.

                onInit:(data, actions) => {
                    // Disable the buttons
                    actions.disable();
                    document.querySelector('#cancel-policy-checkbox').addEventListener('change', function(event) {
                        if (event.target.checked)  {
                            actions.enable();
                            $('.payment-msg').addClass('d-none');
                            $(".btn-place-booking button").removeClass("disabled");
                        } else  {
                            actions.disable();
                            $(".btn-place-booking button").addClass("disabled");
                        }
                    });
                },

                onClick: function() { // https://developer.paypal.com/sdk/js/reference/#link-oninitonclick
                    $('.payment-msg').addClass('d-none');
                    alerts.innerHTML = "";
                    if (!document.querySelector('#cancel-policy-checkbox').checked) {
                        //document.querySelector('#error').classList.remove('hidden');
                        $('.payment-msg').removeClass('d-none');
                        alerts.append(" Have you agreed with the cancellation policy?");
                    }
                },
                style: { //https://developer.paypal.com/sdk/js/reference/#link-style
                    shape: 'rect',
                    color: 'gold',
                    layout: 'vertical',
                    label: 'paypal'
                },
        
                createOrder: async function(data, actions) {
                    // create new purchase order.
                    
                    body = await initOrderRequestBody();
                    //console.log("PAYLOAD: " + JSON.stringify(body));

                    var url = sgttData.root_url + '/wp-json/sgtt/v1/create-order';
                    //console.log(url);
                    if(body){
                        return fetch(url, {
                            method: "post", 
                            headers: { 
                                "Content-Type": "application/json; charset=utf-8",
                                "X-WP-Nonce": sgttData.nonce
                            },
                            body: JSON.stringify({orderId: body})
                        })
                        .then((response) => response.json())
                        .then((order) => { 
                            //console.log(order);
                            return order.id; 
                        })
                    }
                    
                },
        
                onApprove: async function(data, actions) {
                    let order_id = data.orderID;
                    var url = sgttData.root_url + '/wp-json/sgtt/v1/complete-order';
                    console.log(JSON.stringify(data));
                    try {
                        const response = await fetch(url, {
                            method: "post", headers: {
                                "Content-Type": "application/json; charset=utf-8",
                                "X-WP-Nonce": sgttData.nonce
                            },
                            body: JSON.stringify({ "papalOrderId": order_id, "orderId": $("input[name='cart-id']").val() })
                        });
                        const order_details = await response.json();
                        //Close out the PayPal buttons that were rendered
                        paypal_buttons.close();
                        processOrderSuccess(order_details);
                    } catch (error) {
                        // contact admin for queries about transaction.
                        console.log(error);
                        processOrderApproveFailed();
                    }
                },
        
                onCancel: function (data) {
                    // Customer cancel order
                    processCancelOrder();
                },
        
                onError: function(err) {
                    // Created order failed.
                    console.log(err);
                    processOrderFailed();
                }

            });
            paypal_buttons.render('#paypal-button-container');
            

        })
        .catch((err) => {
            // fail to load script smarts paypal buttons. // ERR_INTERNET_DISCONNECTED
            console.error("failed to load the PayPal JS SDK script");
            console.log(err);
            window.alert("Failed to load the Paypal payment.\nPlease check your internet or contact admin to support your checkout. \nThanh you.");
            if(document.getElementsByClassName("payment-msg d-none")[0]){
                document.getElementsByClassName("payment-msg d-none")[0].className = "payment-msg";
            }
            document.getElementById("alerts").innerHTML = 
            `<div class="ms-alert ms-action2 ms-small">
                An error ocurred when loading the Paypal payment.
            </div>`;
        });
    }

}

export default PayGateway;